import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseDatePicker from './ExpenseDatePicker';
import { COLORS } from '../../../utils/Application_Constants';
import moment from 'moment/moment';
import eventBus from './EventBus';

const VendorPaymentStartDate = (props) => {
    const { index, expense, specialLabel = 'Start Date' } = props;
    const { control, errors } = useFormContext();

    return (
        <Grid2 item xs={12} md={6}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].startDate`}
                defaultValue={expense.startDate || null}
                rules={{
                    validate: (value) => {
                        if (!value) {
                            return 'Start Date is required. Please enter a valid date.';
                        }
                        return true;
                    },
                }}
                disabled={props.isViewOnly}
                render={({ onChange, value }) => (
                    <ExpenseDatePicker
                        onChange={(e) => {
                            eventBus.emit(`startDateChanged${index}`, {
                                data: e.startOf('day').format('YYYY-MM-DD'),
                            });
                            onChange(e);
                        }}
                        disabled={props.isViewOnly}
                        value={value ? moment(value) : null}
                        id={`start-date-${index}`}
                        label={specialLabel}
                        required
                        parentTextFieldProps={{
                            error: Boolean(errors.expenseEntries?.[index]?.startDate),
                            helperText: errors.expenseEntries?.[index]?.startDate?.message,
                        }}
                        parentSx={{
                            '& .MuiInputBase-root': {
                                borderColor: !errors.expenseEntries?.[index]?.startDate
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default VendorPaymentStartDate;
